module.exports = __webpack_public_path__ + "static/img/合并地图.3c6f0ec6.png";